"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetContentItemV2Impl = void 0;
var ContentItem_1 = require("../model/ContentItem");
var Url_1 = require("../../utils/Url");
var HttpError_1 = require("../model/HttpError");
var ContentNotFoundError_1 = require("../model/ContentNotFoundError");
/**
 * @hidden
 */
var GetContentItemV2Impl = /** @class */ (function () {
    function GetContentItemV2Impl(config, contentClient, mapper) {
        this.config = config;
        this.contentClient = contentClient;
        this.mapper = mapper;
    }
    GetContentItemV2Impl.prototype.getContentItemByKey = function (key) {
        return this.getContentItem('key', key);
    };
    GetContentItemV2Impl.prototype.getContentItemById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContentItem('id', id)];
            });
        });
    };
    GetContentItemV2Impl.prototype.getContentItem = function (requestType, value) {
        return __awaiter(this, void 0, void 0, function () {
            var args, url, response, err_1, contentItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        args = [
                            ['depth', 'all'],
                            ['format', 'inlined'],
                        ];
                        if (this.config.locale) {
                            args.push(['locale', this.config.locale]);
                        }
                        url = "content/".concat(requestType, "/").concat(value, "?").concat((0, Url_1.encodeQueryString)(args));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contentClient.get(url)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1.response) {
                            if (err_1.response.status === 404) {
                                throw new ContentNotFoundError_1.ContentNotFoundError(value);
                            }
                            else {
                                throw new HttpError_1.HttpError(err_1.response.status, err_1.response.data);
                            }
                        }
                        throw err_1;
                    case 4:
                        contentItem = new ContentItem_1.ContentItem();
                        contentItem.body = this.mapper.toMappedContent(response.data.content);
                        return [2 /*return*/, contentItem];
                }
            });
        });
    };
    return GetContentItemV2Impl;
}());
exports.GetContentItemV2Impl = GetContentItemV2Impl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0Q29udGVudEl0ZW1WMkltcGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvY29vcmRpbmF0b3JzL0dldENvbnRlbnRJdGVtVjJJbXBsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBLG9EQUFtRDtBQUluRCx1Q0FBb0Q7QUFDcEQsZ0RBQStDO0FBQy9DLHNFQUFxRTtBQUdyRTs7R0FFRztBQUNIO0lBRUUsOEJBQ21CLE1BQTZCLEVBQzdCLGFBQTRCLEVBQzVCLE1BQXFCO1FBRnJCLFdBQU0sR0FBTixNQUFNLENBQXVCO1FBQzdCLGtCQUFhLEdBQWIsYUFBYSxDQUFlO1FBQzVCLFdBQU0sR0FBTixNQUFNLENBQWU7SUFDckMsQ0FBQztJQUVKLGtEQUFtQixHQUFuQixVQUNFLEdBQVc7UUFFWCxPQUFPLElBQUksQ0FBQyxjQUFjLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFDSyxpREFBa0IsR0FBeEIsVUFDRSxFQUFVOzs7Z0JBRVYsc0JBQU8sSUFBSSxDQUFDLGNBQWMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLEVBQUM7OztLQUN0QztJQUVLLDZDQUFjLEdBQXBCLFVBQ0UsV0FBeUIsRUFDekIsS0FBYTs7Ozs7O3dCQUVQLElBQUksR0FBRzs0QkFDWCxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUM7NEJBQ2hCLENBQUMsUUFBUSxFQUFFLFNBQVMsQ0FBQzt5QkFDdEIsQ0FBQzt3QkFDRixJQUFJLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxFQUFFOzRCQUN0QixJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQzt5QkFDM0M7d0JBQ0ssR0FBRyxHQUFHLGtCQUFXLFdBQVcsY0FBSSxLQUFLLGNBQUksSUFBQSx1QkFBaUIsRUFBQyxJQUFJLENBQUMsQ0FBRSxDQUFDOzs7O3dCQUk1RCxxQkFBTSxJQUFJLENBQUMsYUFBYSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsRUFBQTs7d0JBQTVDLFFBQVEsR0FBRyxTQUFpQyxDQUFDOzs7O3dCQUU3QyxJQUFJLEtBQUcsQ0FBQyxRQUFRLEVBQUU7NEJBQ2hCLElBQUksS0FBRyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFO2dDQUMvQixNQUFNLElBQUksMkNBQW9CLENBQUMsS0FBSyxDQUFDLENBQUM7NkJBQ3ZDO2lDQUFNO2dDQUNMLE1BQU0sSUFBSSxxQkFBUyxDQUFDLEtBQUcsQ0FBQyxRQUFRLENBQUMsTUFBTSxFQUFFLEtBQUcsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7NkJBQzdEO3lCQUNGO3dCQUVELE1BQU0sS0FBRyxDQUFDOzt3QkFHTixXQUFXLEdBQUcsSUFBSSx5QkFBVyxFQUFLLENBQUM7d0JBQ3pDLFdBQVcsQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQzt3QkFDdEUsc0JBQU8sV0FBVyxFQUFDOzs7O0tBQ3BCO0lBQ0gsMkJBQUM7QUFBRCxDQUFDLEFBbkRELElBbURDO0FBbkRZLG9EQUFvQiJ9